import { ActionContext, ActionTree } from "vuex";
import State from "@/store/reservation/state";
import { ReservationDetail } from "@/model/ReservationDetail";
import { Support } from "@/model/Support";
import requestService from "@/service/requestService";
import { ShakenMode, ShakenStorage } from "@/service/storage";

// ActionTree<[current state], [root state]>
const actions: ActionTree<State, any> = {
  init(
    { commit }: ActionContext<State, any>,
    payload: ReservationDetail
  ): void {
    commit("init", payload);
  },
  // 画面表示前に予約詳細を確保する。保存情報がなければガード側で遷移する。
  ensureState(
    { state, dispatch }: ActionContext<State, any>,
    mode: ShakenMode = ShakenStorage.getMode()
  ): Promise<boolean> {
    if (state.isLoadUketsuke && state.uketsukeCd && state.uketsukeExtendsId != null) {
      return Promise.resolve(true);
    }
    return dispatch("restoreState", mode);
  },
  restoreState(
    { commit }: ActionContext<State, any>,
    mode: ShakenMode = ShakenStorage.getMode()
  ): Promise<boolean> {
    const context = ShakenStorage.getReservationContext(mode);
    if (!context) {
      return Promise.resolve(false);
    }
    const service = new requestService();
    return service.getReservationDetail(context.code, mode === "user").then((detail: any) => {
      commit("init", detail as ReservationDetail);
      return true;
    });
  },
  setUketsukeCd({ commit }: ActionContext<State, any>, payload: string): void {
    commit("setUketsukeCd", payload);
  },
  updateMemo({ commit }: ActionContext<State, any>, payload: string): void {
    commit("updateMemo", payload);
  },
  updateSoukouKm(
    { commit }: ActionContext<State, any>,
    payload: { id: string; value: number }
  ): void {
    commit("updateSoukouKm", payload);
  },
  updateSoukouKmAvg(
    { commit }: ActionContext<State, any>,
    payload: { id: string; value: number }
  ): void {
    commit("updateSoukouKmAvg", payload);
  },
  updateSoukouMile(
    { commit }: ActionContext<State, any>,
    payload: { id: string; value: number }
  ): void {
    commit("updateSoukouMile", payload);
  },
  updateSoukouMileAvg(
    { commit }: ActionContext<State, any>,
    payload: { id: string; value: number }
  ): void {
    commit("updateSoukouMileAvg", payload);
  },
  updateSoukouUnitKbn(
    { commit }: ActionContext<State, any>,
    payload: { id: string; value: number }
  ): void {
    commit("updateSoukouUnitKbn", payload);
  },
  updateSoukouBikouKbn(
    { commit }: ActionContext<State, any>,
    payload: { id: string; value: number }
  ): void {
    commit("updateSoukouBikouKbn", payload);
  },
  updateLaborRate(
    // laborRateKingakuZn
    { commit }: ActionContext<State, any>,
    payload: { id: string; value: number }
  ): void {
    commit("updateLaborRate", payload);
  },
  initSupport(
    { commit }: ActionContext<State, any>,
    payload: { id: string; value: Support }
  ): void {
    commit("initSupport", payload);
  },
  updateFrontStaff(
    { commit }: ActionContext<State, any>,
    payload: { id: string; value: Support }
  ): void {
    commit("updateFrontStaff", payload);
  },
  clearState({ commit }: ActionContext<State, any>): void {
    commit("clearState");
  },
  updateOmonaYouto(
    { commit }: ActionContext<State, any>,
    payload: { omonaYouto: number; omonaYoutoNm: string }
  ): void {
    commit("updateOmonaYouto", payload);
  },
  setIsStart({ commit }: ActionContext<State, any>, payload: boolean): void {
    commit("setIsStart", payload);
  },
  updateMakerModel(
    { commit }: ActionContext<State, any>,
    payload: {
      srMakerCd: string;
      srModelCd: string;
      srMakerNm: string;
      srModelNm: string;
    }
  ): void {
    commit("updateMakerModel", payload);
  },
  updateConfirmation(
    { commit }: ActionContext<State, any>,
    payload: { num: number; value: number }
  ): void {
    commit("updateConfirmation", payload);
  },
  updateRyoukinRankCd({ commit }: ActionContext<State, any>, payload: string): void {
    commit("updateRyoukinRankCd", payload);
  },
  setUketsukeExtendsId({ commit }: ActionContext<State, any>, payload: string): void {
    commit("setUketsukeExtendsId", payload);
  }
};

export default actions;
